<template>
  <el-container class="container" style="padding:0;">
    <!-- 侧边栏 -->
    <el-aside width="200px" style="background: rgb(246, 248, 251);height:100%">
      <LeftBar :left-items="leftItems" :currentSelectLeftItemKey="currentSelectLeftItemKey" @selectChange="leftItemselectChange"/>
    </el-aside>
    <!-- 内容区域 -->
    <!-- 一、客户主页 -->
    <div class='content-container' v-show="isShow('ClientPage')" style="overflow:scroll">
      <ClientPage @leftItemselectChange="leftItemselectChange" />
    </div>
    <!-- 二、客户列表  -->
    <div class='content-container' v-show="isShow('table')"  style="overflow:scroll">
      <ClientList />
    </div>
  </el-container>
</template>

<script>
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import ClientPage from "@/component/Client/ClientPage/ClientPage";
import ClientList from "@/component/Client/ClientList/ClientList";

export default {
  name: "Client",
  components:{
    ClientList,
    LeftBar,
    ClientPage
  },
  data(){
    return {
      leftItems:[
        {
          id:0,
          name:'客户首页',
          key:'ClientList',
          type:'ClientPage'
        },
        {
          id:1,
          name:'客户列表',
          key:'ClientContent',
          type:'table'
        }
      ],
      currentSelectLeftItemKey:'ClientList'
    }
  },
  computed:{
    isShow(){
      return (type) =>{
        return this.leftItems.find(item=>item.key==this.currentSelectLeftItemKey)&&this.leftItems.find(item=>item.key==this.currentSelectLeftItemKey).type==type
      }
    }
  },

  methods:{
    leftItemselectChange(key){
      this.currentSelectLeftItemKey = key
    }
  }

}
</script>

<style scoped>
  .content-container{
    padding: 20px;
    box-sizing: border-box;
    width: calc(100% - 200px);
    /* width: 100%; */
  }

</style>